module.exports = __webpack_public_path__ + "static/25-thumb-5e47db0114929eb16f42878a403672c3.jpg";